import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'app/types';

import { initialState } from './slice';

const selectDomain = (state: RootState) => state.groups || initialState;

export const selectGroups = createSelector(
  [selectDomain],
  groupsState => groupsState,
);
